import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap'
import styles from './OpenStarChestInfoModal.module.scss';

import closeIcon from '../../assets/icons/btn-close-X.svg';
import gameStarsCollection from '../../assets/imgs/game-stars-collection.png';
import allChests from '../../assets/imgs/allChests.png';
import unlockChestImage from '../../assets/imgs/unlock-chest-image.png';

const OpenStarChestInfoModal = (props) => {
    const [t] = useTranslation();
    const { starModal, setStarModal, title, body } = props;
    const [modalPageNum, setModalPageNum] = useState(1); // by default first page of the modal should load
    const [modalBody, setModalBody] = useState(body);

    const renderModalTitleAndBody = () => {
        return(
            <>
            <h4 className={styles.star_title}>
                {title}?
            </h4>
            <div className={styles.star_chestInfo}>
                <p>
                    {modalBody}
                </p>
            </div> 
            </>
        )
    }

    useEffect (() => {
        if(modalPageNum === 3) {
            setModalBody(t('FIND_STAR_CHEST_AND_CLICK_OPEN'));
        }
        else if(modalPageNum === 2) {
            setModalBody(t('CLICK_CHEST_IN_MENU_BAR'));
        }
        else {
            setModalBody(t('EARN_STAR_CHEST_GETTING_STARS_IN_GAME'))
        }
    }, [modalPageNum]);

    const renderModalImage = () => {
        let imageToRenderSrc;
        if(modalPageNum === 3) {
            imageToRenderSrc = unlockChestImage;
        } 
        else if(modalPageNum === 2) {
            imageToRenderSrc = allChests;
        }
        else {
            imageToRenderSrc = gameStarsCollection;
        }
        return(
            <div className={styles.star_chest_bg}>
                <img src={imageToRenderSrc} alt="game-stars-collection" />
            </div>
        )
    }

    return (
        <Modal show={starModal} className={styles.star_modal}  centered contentClassName={styles.star_modalContent} dialogClassName={styles.star_modalDialog} onHide={() => setStarModal(false)}>
            <button className={styles.close_btn} onClick={()=> setStarModal(false)}>
                <img src={closeIcon} alt="" />
            </button>
            <Modal.Body bsPrefix={styles.star_modalBody}>
                { renderModalTitleAndBody() }
                { renderModalImage() }

                <div className={styles.progress_bar}>
                    <div className={`${styles.number_points} ${modalPageNum === 1 ? styles.number_points_selected : ''}`} onClick={() => setModalPageNum(1)}>1</div>
                    <div className={styles.horizontal_bar}></div>
                    <div className={`${styles.number_points} ${modalPageNum === 2 ? styles.number_points_selected : ''}`} onClick={() => setModalPageNum(2)}>2</div>
                    <div className={styles.horizontal_bar}></div>
                    <div className={`${styles.number_points} ${modalPageNum === 3 ? styles.number_points_selected : ''}`} onClick={() => setModalPageNum(3)}>3</div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export { OpenStarChestInfoModal };